import { c as _c } from "react/compiler-runtime";
import useIsBrowser from 'hooks/useIsBrowser';

// Please note: when possible it is preferred that responsive width-based
// conditional checks such as the isMobile function are used, but in rare cases
// where we need to check for iPad user agents we can use this hook.
const useIsiPadUserAgent = () => {
  const $ = _c(2);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== isBrowser) {
    t0 = isBrowser && (navigator?.userAgent && navigator.userAgent.match(/(iPad)/) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    $[0] = isBrowser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default useIsiPadUserAgent;